import { useEffect, useState } from "react";
import { Download, X, Share } from "lucide-react";

const DISMISS_KEY = "need_install_dismissed";
const DISMISS_DAYS = 7;

const isStandalone = () =>
  window.matchMedia("(display-mode: standalone)").matches || window.navigator.standalone === true;

const isIOS = () => /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;

export const InstallPrompt = () => {
  const [deferred, setDeferred] = useState(null);
  const [visible, setVisible] = useState(false);
  const [ios] = useState(isIOS);

  useEffect(() => {
    if (isStandalone()) return;
    const dismissed = Number(localStorage.getItem(DISMISS_KEY) || 0);
    if (Date.now() - dismissed < DISMISS_DAYS * 864e5) return;

    const onPrompt = (e) => {
      e.preventDefault();
      setDeferred(e);
      setVisible(true);
    };
    window.addEventListener("beforeinstallprompt", onPrompt);
    if (ios) setVisible(true);
    return () => window.removeEventListener("beforeinstallprompt", onPrompt);
  }, [ios]);

  if (!visible) return null;

  const install = async () => {
    if (!deferred) return;
    deferred.prompt();
    await deferred.userChoice;
    setVisible(false);
  };

  const dismiss = () => {
    localStorage.setItem(DISMISS_KEY, String(Date.now()));
    setVisible(false);
  };

  return (
    <div
      data-testid="install-prompt-banner"
      className="safe-bottom fixed inset-x-4 z-50 mx-auto flex max-w-md items-center gap-3 rounded-2xl border border-electric/40 bg-panel/95 p-4 shadow-[0_0_40px_rgba(0,163,255,0.25)] backdrop-blur-xl"
    >
      <img src="/icon-192.png" alt="NEED" className="h-12 w-12 rounded-xl" />
      <div className="min-w-0 flex-1">
        <p className="text-sm font-bold text-ink">Installa NEED</p>
        {ios ? (
          <p className="text-xs text-ink-soft" data-testid="install-prompt-ios-hint">
            Tocca <Share className="inline h-3 w-3" /> e poi &quot;Aggiungi a Home&quot;
          </p>
        ) : (
          <p className="text-xs text-ink-soft">Un tap e NEED vive sul tuo telefono</p>
        )}
      </div>
      {!ios && (
        <button
          data-testid="install-prompt-button"
          onClick={install}
          className="flex items-center gap-1.5 rounded-full bg-sage px-4 py-2 text-xs font-bold text-cream transition-colors hover:bg-sage-deep"
        >
          <Download className="h-3.5 w-3.5" /> Installa
        </button>
      )}
      <button
        data-testid="install-prompt-dismiss"
        onClick={dismiss}
        aria-label="Chiudi"
        className="rounded-full p-1.5 text-ink-soft transition-colors hover:text-ink"
      >
        <X className="h-4 w-4" />
      </button>
    </div>
  );
};
